module.exports = __webpack_public_path__ + "img/DS725+.5a2ab4ee.png";